export default __webpack_public_path__ + "static/media/img12.e474038a.PNG";